import type { FeatureFlag } from '@actual-app/core/types/prefs';

import { useSyncedPref } from './useSyncedPref';

const DEFAULT_FEATURE_FLAG_STATE: Record<FeatureFlag, boolean> = {
  newSidebarUI: false,
  // Presupuesto: los objetivos importados de YNAB son plantillas, así que la
  // columna de objetivo/infrafinanciado se ve sin pasar por «Experimental».
  goalTemplatesEnabled: true,
  goalTemplatesUIEnabled: false,
  actionTemplating: false,
  currency: false,
  balanceForecastReport: false,
  customThemes: false,
  budgetAnalysisReport: false,
  // Presupuesto: CaixaBank y Trade Republic se conectan por Enable Banking.
  enableBanking: true,
  sankeyReport: false,
  // Rumbo: ningún importe abre el teclado del móvil (regla fija); el del
  // movimiento, dividir y cuadrar usan la calculadora de la app.
  mobileCalculator: true,
  monteCarloReport: false,
};

export function useFeatureFlag(name: FeatureFlag): boolean {
  const [value] = useSyncedPref(`flags.${name}`);

  return value === undefined
    ? DEFAULT_FEATURE_FLAG_STATE[name] || false
    : String(value) === 'true';
}
